import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { redirectTo } from '../../conf-utility/conf-configuration';
import { environment } from '../../../../environments/environment';
@Component({
  selector: 'app-conf-error-404',
  templateUrl: './conf-error404.component.html',
  styleUrls: ['./conf-error404.component.scss']
})
export class ConfError404Component implements OnInit {
  confAWSUrlStr: any = environment.confAWSurl;
  constructor(private router: Router) { }
 
  ngOnInit(): void {
  }

  backToHome() {
    this.router.navigate(['/' + redirectTo]);

  }

}
